export const getEnvVariables = (): ImportMetaEnv => import.meta.env;